<template>
    <div v-show="show" id="background">
        <span id="title" ref="cursorPainterTitle"></span>
        <img id="close" src="@/assets/art/paint_board/close.svg" @click="close()" />
        <CursorPaintSetting ref="cursorPaintSetting" />
        <div id="CursorPainterConfirm">
            <span @click="saveSetting(), close()">套用</span>
        </div>
    </div>
</template>

<script>
import DEFINE from '@/js/painter/define';
import CursorPaintSetting from "@/components/cursor/CursorPaintSetting.vue";

export default {
    name: "CursorPaintBoard",
    components: { CursorPaintSetting },
    emits: [
        'updatePainter'
    ],
    data: function () {
        return {
            show: false,
            operate: DEFINE.OPERATE.PEN
        };
    },
    methods: {
        open() {
            this.show = true;
        },
        close() {
            this.show = false;
        },
        update() {
            this.$refs.cursorPainterTitle.innerText = (this.operate == DEFINE.OPERATE.PEN) ? "畫筆" : "螢光筆";

            this.$refs.cursorPaintSetting.operate = this.operate;
            this.$refs.cursorPaintSetting.updateColor();
        },
        set(operate, input) {
            this.operate = operate;
            this.update();
            this.$refs.cursorPaintSetting.setColor(input.colorSetting);
            this.$refs.cursorPaintSetting.setDrawTool(input.brushSetting);
            this.$refs.cursorPaintSetting.setWidth(input.brushSize);
            this.$refs.cursorPaintSetting.setHollow(input.soildSetting);
        },
        saveSetting: function () {
            this.$emit('updatePainter', this.$refs.cursorPaintSetting.getData());
        }
    },
    mounted: function () {
        this.update();
    }
};
</script>

<style scoped>
@import "@/css/cursor/PaintBoard.css";

#background {
    position: fixed;
    background-color: rgb(79, 124, 252);
    border-radius: 0.8em;
    width: 1060px;
    height: 400px;
    left: calc(50% - 530px);
    bottom: max(10%, 80px);
    z-index: var(--z-index-white-board);
}
</style>